import { Product } from "@/@core/entity/product.entity";
import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";
export interface GetProductDetailDTO {
  id: string | undefined;
}

export type GetUsetResp = BaseResAPI<Product>;

const getProductDetailInteractor = (
  params: GetProductDetailDTO
): Promise<GetUsetResp> => {
  const path = `/admin/product/${params.id}`;

  let pathParam = "?";

  return api.get(pathParam === "?" ? path : path + pathParam);
};

export default getProductDetailInteractor;
